<template>
  <a-drawer :destroy-on-close="true" :title="isUpdate ? '信息系统编辑' : '信息系统创建'" :visible="visible" :width="800"
    @close="closeDrawer">
    <a-form-model ref="form" :label-col="{
      span: 6,
      style: {
        textAlign: 'left'
      }
    }" :model="form" :rules="rules" :wrapper-col="{
      span: 18
    }">
      <a-form-model-item label="责任处室" prop="department">
        <a-input v-model="form.department" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="业务系统名称" prop="name">
        <a-input v-model="form.name" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="项目名称" prop="project">
        <a-input v-model="form.project" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="建设时间" prop="builtAt">
        <a-date-picker v-model="form.builtAt" style="width: 100%"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="上线时间" prop="launchedAt">
        <a-date-picker v-model="form.launchedAt" style="width: 100%"></a-date-picker>
      </a-form-model-item>

      <a-form-model-item label="合同金额" prop="contractAmount">
        <a-input-number v-model="form.contractAmount" :precision="2" :min="0" :step="0.01" style="width: 100%"
          placeholder="请输入合同金额"></a-input-number>
      </a-form-model-item>

      <a-form-model-item label="合同到期时间" prop="contractEndDate">
        <a-date-picker v-model="form.contractEndDate" style="width: 100%"></a-date-picker>
      </a-form-model-item>

      <a-form-model-item label="合同资金来源" prop="contractFundingSource">
        <a-input v-model="form.contractFundingSource" ></a-input>
      </a-form-model-item>



      <a-form-model-item label="项目合同签订日期" prop="signedAt">
        <a-date-picker v-model="form.signedAt" style="width: 100%"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="最近一次等保级别" prop="lastLevel">
        <simple-select :options="levelOptions" :autoSelect="false" :label-in-value="false" v-model="form.lastLevel"
          style="width: 100%"></simple-select>
      </a-form-model-item>
      <a-form-model-item label="最近一次等保测评完成时间" prop="lastEvaluatedAt">
        <a-date-picker v-model="form.lastEvaluatedAt" style="width: 100%"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="等保测评公司" prop="evaluateCompany">
        <a-input v-model="form.evaluateCompany" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="等保测评负责人" prop="evaluateManager">
        <a-input v-model="form.evaluateManager" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="等保测评负责人联系电话" prop="evaluateManagerPhone">
        <a-input v-model="form.evaluateManagerPhone" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="最近一次软测时间" prop="lastTestedAt">
        <a-date-picker v-model="form.lastTestedAt" style="width: 100%"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="软件测评公司" prop="testCompany">
        <a-input v-model="form.testCompany" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="软测负责人" prop="testManager">
        <a-input v-model="form.testManager" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="软测负责人联系电话" prop="testManagerPhone">
        <a-input v-model="form.testManagerPhone" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="系统负责人" prop="projectManager">
        <a-input v-model="form.projectManager" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="系统负责人联系电话" prop="projectManagerPhone">
        <a-input v-model="form.projectManagerPhone" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="备案证号" prop="recordNumber">
        <a-input v-model="form.recordNumber" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="备案时间" prop="recordedAt">
        <a-date-picker v-model="form.recordedAt" style="width: 100%"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="网址" prop="address">
        <a-input v-model="form.address" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="运维公司" prop="operationCompany">
        <simple-select v-model="form.operationCompany" :options="operationCompanyOptions" :autoSelect="false"
          :filter-option="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
          :show-search="true" style="width: 100%"></simple-select>

      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 18, offset: 6 }" style="margin-bottom: 0">
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import {
  getServiceInventory,
  updateServiceInventory,
  createServiceInventory,
  getOperationCompanyList
} from '@/api/inventory.js'
import SimpleSelect from '@/components/select/SimpleSelect.vue'

export default {
  name: 'InputDrawer',
  components: {
    SimpleSelect
  },
  data() {
    const levelOptions = []
    for (let i = 1; i < 6; i++) {
      levelOptions.push({
        label: this.$t(`service_level.${i}`),
        value: i
      })
    }
    return {
      value: "",
      levelOptions,
      visible: false,
      isUpdate: false,
      options: [...Array(25)].map((_, i) => ({ value: (i + 10).toString(36) + (i + 1) })),

      form: {
        id: '',
        department: '',
        name: '',
        project: '',
        builtAt: undefined,
        launchedAt: undefined,

        contractAmount: 0,
        contractEndDate: undefined,
        contractFundingSource: '',


        signedAt: undefined,
        lastLevel: '',
        lastEvaluatedAt: undefined,
        evaluateCompany: '',
        evaluateManager: '',
        evaluateManagerPhone: '',
        lastTestedAt: undefined,
        testCompany: '',
        testManager: '',
        testManagerPhone: '',
        projectManager: '',
        projectManagerPhone: '',
        recordNumber: '',
        recordedAt: undefined,
        address: '',
        operationCompany: undefined
      },
      rules: {
        name: [
          {
            message: '请输入业务系统名称',
            required: true,
            trigger: 'blur'
          }
        ],
        contractFundingSource: [  
          {
            max: 16,
            message: '合同资金来源长度不能超过16个字符',
            trigger: 'blur'
          }
        ]
      },
      loading: false,
      operationCompanyOptions: []
    }
  },
  methods: {
    show(id) {
      this.fetchCompany()
      if (id) {
        this.isUpdate = true
        getServiceInventory(id)
          .then(res => {
            const data = res.data
            this.form = {
              id: data.id,
              department: data.department,
              name: data.name,
              project: data.project,
              builtAt: data.built_at ? moment(data.built_at, 'YYYY-MM-DD') : undefined,
              launchedAt: data.launched_at ? moment(data.launched_at, 'YYYY-MM-DD') : undefined,

              contractAmount: data.contract_amount,
              contractEndDate: data.contract_end_date ? moment(data.contract_end_date, 'YYYY-MM-DD') : undefined,
              contractFundingSource: data.contract_funding_source,


              signedAt: data.signed_at ? moment(data.signed_at, 'YYYY-MM-DD') : undefined,
              lastLevel: data.last_level,
              lastEvaluatedAt: data.last_evaluated_at ? moment(data.last_evaluated_at, 'YYYY-MM-DD') : undefined,
              evaluateCompany: data.evaluate_company,
              evaluateManager: data.evaluate_manager,
              evaluateManagerPhone: data.evaluate_manager_phone,
              lastTestedAt: data.last_tested_at ? moment(data.last_tested_at, 'YYYY-MM-DD') : undefined,
              testCompany: data.test_company,
              testManager: data.test_manager,
              testManagerPhone: data.test_manager_phone,
              projectManager: data.project_manager,
              projectManagerPhone: data.project_manager_phone,
              recordNumber: data.record_number,
              recordedAt: data.recorded_at ? moment(data.recorded_at, 'YYYY-MM-DD') : undefined,
              address: data.address,
              operationCompany: data.operation_company ? { label: data.operation_company.name, value: data.operation_company.id } : undefined
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    closeDrawer() {
      this.form = {
        id: '',
        department: '',
        name: '',
        project: '',
        builtAt: undefined,
        launchedAt: undefined,

        contractAmount: 0,
        contractEndDate: undefined,
        contractFundingSource: '',

        signedAt: undefined,
        lastLevel: '',
        lastEvaluatedAt: undefined,
        evaluateCompany: '',
        evaluateManager: '',
        evaluateManagerPhone: '',
        lastTestedAt: undefined,
        testCompany: '',
        testManager: '',
        testManagerPhone: '',
        projectManager: '',
        projectManagerPhone: '',
        recordNumber: '',
        recordedAt: undefined,
        address: '',
        operationCompany: undefined
      }
      this.isUpdate = false
      this.operationCompanyOptions = []
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            name: this.form.name
          }
          if (this.form.department) params.department = this.form.department
          if (this.form.project) params.project = this.form.project
          if (this.form.builtAt) params.built_at = this.form.builtAt.format('YYYY-MM-DD')
          if (this.form.launchedAt) params.launched_at = this.form.launchedAt.format('YYYY-MM-DD')

          if (this.form.contractAmount) params.contract_amount = this.form.contractAmount
          if (this.form.contractEndDate) params.contract_end_date = this.form.contractEndDate.format('YYYY-MM-DD')
          if (this.form.contractFundingSource) params.contract_funding_source = this.form.contractFundingSource


          if (this.form.signedAt) params.signed_at = this.form.signedAt.format('YYYY-MM-DD')
          if (this.form.lastLevel) params.last_level = this.form.lastLevel
          if (this.form.lastEvaluatedAt) params.last_evaluated_at = this.form.lastEvaluatedAt.format('YYYY-MM-DD')
          if (this.form.evaluateCompany) params.evaluate_company = this.form.evaluateCompany
          if (this.form.evaluateManager) params.evaluate_manager = this.form.evaluateManager
          if (this.form.evaluateManagerPhone) params.evaluate_manager_phone = this.form.evaluateManagerPhone
          if (this.form.lastTestedAt) params.last_tested_at = this.form.lastTestedAt.format('YYYY-MM-DD')
          if (this.form.testCompany) params.test_company = this.form.testCompany
          if (this.form.testManager) params.test_manager = this.form.testManager
          if (this.form.testManagerPhone) params.test_manager_phone = this.form.testManagerPhone
          if (this.form.projectManager) params.project_manager = this.form.projectManager
          if (this.form.projectManagerPhone) params.project_manager_phone = this.form.projectManagerPhone
          if (this.form.recordNumber) params.record_number = this.form.recordNumber

          if (this.form.recordedAt) params.recorded_at = this.form.recordedAt.format('YYYY-MM-DD')

          if (this.form.address) params.address = this.form.address
          if (this.form.operationCompany) params.operation_company_id = this.form.operationCompany.value
          if (this.isUpdate) {
            updateServiceInventory(this.form.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            createServiceInventory(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    },
    fetchCompany() {
      getOperationCompanyList().then(res => {
        if (res.data && res.data.total) {
          this.operationCompanyOptions = res.data.data.map(item => {
            return {
              label: item.name,
              value: item.id
            }
          })
        }
      })
    }

  }
}
</script>
